import React from 'react';
import { Flex, Switch as AntdSwitch } from 'antd';
import Label from '../label/Label';

const Switch = ({
  label = '',
  size = 'default',
  checked = false,
  handleChange = () => {},
  labelClassName = '',
  loading = false,
  switchStyle = {},
  disabled = false,
  ...style
}) => {
  return (
    <Flex align="center" justify="space-between" gap={8} {...style}>
      {label && (
        <Label className={labelClassName} style={{ marginBlockEnd: '0px' }}>
          {label}
        </Label>
      )}
      <AntdSwitch
        checked={checked}
        onChange={handleChange}
        size={size}
        loading={loading}
        style={switchStyle}
        disabled={disabled}
      />
    </Flex>
  );
};

export default Switch;
